import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import * as admin from '../../api/admin.ts';
import { formatDateTime } from '../../lib/format.ts';
import { EmptyState } from '../common/EmptyState.tsx';

const FILTERS = [
  { value: '', label: '전체' },
  { value: 'auth.', label: '인증' },
  { value: 'job.', label: '백그라운드 잡' },
  { value: 'admin.', label: '관리자 동작' },
  { value: 'share.', label: '공유' },
];

interface AuditRow {
  id: number;
  action: string;
  actor_name: string | null;
  meta: Record<string, unknown>;
  ip: string | null;
  created_at: string;
}

export function AuditTab() {
  const [filter, setFilter] = useState('');
  const { data, isLoading } = useQuery({
    queryKey: ['admin-audit', filter],
    queryFn: () => admin.auditLog(filter || undefined),
  });

  const items = (data?.items ?? []) as unknown as AuditRow[];

  return (
    <>
      <div className="dl__tabs" style={{ marginBottom: 12 }}>
        {FILTERS.map((f) => (
          <button
            key={f.value}
            className={filter === f.value ? 'btn btn--sm btn--primary' : 'btn btn--sm'}
            onClick={() => { setFilter(f.value); }}
          >
            {f.label}
          </button>
        ))}
      </div>

      {isLoading && <span className="spinner" />}
      {!isLoading && items.length === 0 && <EmptyState title="기록이 없습니다" />}

      {items.map((row) => (
        <div key={row.id} className="frow" style={{ gridTemplateColumns: '190px 130px 1fr 160px' }}>
          <div className="frow__meta mono truncate" title={row.action}>{row.action}</div>
          <div className="frow__meta truncate">{row.actor_name ?? '시스템'}</div>
          <div className="frow__meta mono truncate" title={JSON.stringify(row.meta)}>
            {JSON.stringify(row.meta)}
          </div>
          <div className="frow__meta">
            {formatDateTime(row.created_at)}
            {row.ip && <div className="faint" style={{ fontSize: 11 }}>{row.ip}</div>}
          </div>
        </div>
      ))}
    </>
  );
}
